import React from 'react'
import styled from 'styled-components'
import { size } from './platform'

export const MenuContainer = styled((props: any) => (
  <ul {...props}>{props.children}</ul>
))`
  margin: 0;
  padding: 0;
  display: flex;
  width: 100%;

  @media only screen and (max-width: ${size.md}) {
    flex-direction: column;
    width: 100%;
  }
`
